import Service from '@/helpers/service'

export default {

    get() {
        return Service().get('InspectionType');
    }, 
}